import { ApiClientBase } from "./apiClientBase";
import { getCurrentStageConfig, type StageConfig } from "./stageConfig";

const currentStage: StageConfig = getCurrentStageConfig();
const qrStoreApiClient = new ApiClientBase({ baseURL: currentStage.baseUrl, userType: "" });
const qrStoreCustomerApiClient = new ApiClientBase({ baseURL: currentStage.baseUrl, userType: "customer" });
export const qrStoreApi = qrStoreApiClient.api();
export const qrStoreCustomerApi = qrStoreCustomerApiClient.api();
